import axios from '@/libs/api.request'

export const getTheaterList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/theater'
  })
}

export const addTheater = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/theater'
  })
}

export const editTheater = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/theater'
  })
}

export const changeTheaterStatus = (id) => {
  return axios.request({
    method: 'put',
    url: '/theater/' + id
  })
}

export const delTheater = (id, idempotencyKey) => {
  return axios.request({
    method: 'delete',
    headers: idempotencyKey
      ? { 'Idempotency-Key': idempotencyKey }
      : {},
    url: '/theater/' + id
  })
}

export const getTheaterInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/theater/' + id
  })
}

export const getTheaterPlay = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/theater/play'
  })
}

export const addTheaterPlay = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/theater/play'
  })
}

export const editTheaterPlay = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/theater/play'
  })
}

export const delTheaterPlay = (data) => {
  return axios.request({
    method: 'delete',
    data,
    url: '/theater/play'
  })
}

export const getTheaterPlayNotIn = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/theater/play/notIn'
  })
}

export const changeSticky = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/theater/play/sticky'
  })
}

export const getTheaterPlayTop100 = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/theater/play/top100'
  })
}

export const getTheaterPlayPageByCondition = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/theater/play/pageByCondition'
  })
}

export const editTheaterPlaySort = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/theater/play/sort'
  })
}
